// Border Radius Values
export const APPROVAL_BORDER_RADIUS_SM = '0.1875rem';
export const APPROVAL_BORDER_RADIUS_MD = '0.375rem';
export const APPROVAL_BORDER_RADIUS_LG = '16px';
export const APPROVAL_BORDER_RADIUS_CARD = '8px';

// Background Colors
export const APPROVAL_BG_LIGHT = '#F5F5F5';
export const APPROVAL_BG_MEDIUM = '#F9F9F9';
export const APPROVAL_BG_WHITE = '#FFFFFF';
export const APPROVAL_BG_MUTED = '#fafafa';
export const APPROVAL_BG_WARNING = '#fff4e5';
export const APPROVAL_BG_SUCCESS = '#edf7ed';

// Border Colors
export const APPROVAL_BORDER_LIGHT = '1px solid rgba(0, 0, 0, 0.1)';
export const APPROVAL_BORDER_SLIGHT = '1px solid #e5e7eb';
export const APPROVAL_BORDER_DASHED = '1px dashed #d1d5db';
export const APPROVAL_BORDER_DIVIDER = '1px solid #f0f0f0';
